import React from "react";
import "../printStyles.css";

function InvoiceTemplate() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * { visibility: hidden; }
            #InvoiceTemplate, #InvoiceTemplate * { visibility: visible; }
            #InvoiceTemplate {
              position: absolute;
              left: 0; top: 0;
              width: 100%;
              margin: 0; padding: 0;
              box-shadow: none; border: none;
            }
            @page { size: A4 landscape; margin: 15mm; }
            .print-button { display: none; }
          }
          /* Ensure table borders print nicely */
          #InvoiceTemplate table { border-collapse: collapse; width: 100%; }
          #InvoiceTemplate th, #InvoiceTemplate td { border: 1px solid #000; padding: 6px; font-size: 12px; }
        `}
      </style>

      <div id="InvoiceTemplate" className="p-6 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Invoice</h3>

        {/* Company & Client Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div>
            <h4 className="text-lg font-semibold mb-2">Your Company</h4>
            <div className="space-y-2">
              <input className="p-2 border rounded w-full" placeholder="Company Name" />
              <input className="p-2 border rounded w-full" placeholder="Address Line 1" />
              <input className="p-2 border rounded w-full" placeholder="Address Line 2" />
              <input className="p-2 border rounded w-full" placeholder="City / Postcode" />
              <div className="grid grid-cols-2 gap-2">
                <input className="p-2 border rounded w-full" placeholder="Company No." />
                <input className="p-2 border rounded w-full" placeholder="VAT No." />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <input className="p-2 border rounded w-full" placeholder="Phone" />
                <input className="p-2 border rounded w-full" placeholder="Email" />
              </div>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Bill To (Client)</h4>
            <div className="space-y-2">
              <input className="p-2 border rounded w-full" placeholder="Client Company Name" />
              <input className="p-2 border rounded w-full" placeholder="Address Line 1" />
              <input className="p-2 border rounded w-full" placeholder="Address Line 2" />
              <input className="p-2 border rounded w-full" placeholder="City / Postcode" />
              <div className="grid grid-cols-2 gap-2">
                <input className="p-2 border rounded w-full" placeholder="Contact Name" />
                <input className="p-2 border rounded w-full" placeholder="Contact Email" />
              </div>
            </div>
          </div>
        </div>

        {/* Invoice Meta */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
          <div>
            <label className="block text-sm font-medium">Invoice No.</label>
            <input className="p-2 border rounded w-full" placeholder="INV-0001" />
          </div>
          <div>
            <label className="block text-sm font-medium">Invoice Date</label>
            <input type="date" className="p-2 border rounded w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium">PO / Reference</label>
            <input className="p-2 border rounded w-full" placeholder="PO-12345" />
          </div>
          <div>
            <label className="block text-sm font-medium">Terms / Due Date</label>
            <div className="grid grid-cols-2 gap-2">
              <input className="p-2 border rounded w-full" placeholder="Net 30" />
              <input type="date" className="p-2 border rounded w-full" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
          <div>
            <label className="block text-sm font-medium">Currency</label>
            <input className="p-2 border rounded w-full" placeholder="GBP" />
          </div>
          <div>
            <label className="block text-sm font-medium">Remittance Email</label>
            <input className="p-2 border rounded w-full" placeholder="accounts@yourco.co.uk" />
          </div>
          <div>
            <label className="block text-sm font-medium">Job/Contract Ref</label>
            <input className="p-2 border rounded w-full" placeholder="Route/Contract/Booking Ref" />
          </div>
        </div>

        {/* Line Items */}
        <h4 className="text-lg font-semibold mb-2">Line Items</h4>
        <table className="mb-4">
          <thead>
            <tr>
              <th style={{ width: '40px' }}>#</th>
              <th>Description</th>
              <th style={{ width: '80px' }}>Qty</th>
              <th style={{ width: '110px' }}>Unit Price</th>
              <th style={{ width: '80px' }}>VAT %</th>
              <th style={{ width: '120px' }}>Line Total</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 10 }).map((_, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td><input className="p-2 border rounded w-full" placeholder="Description (e.g., Delivery: VRN ABC123, 01/09, 120 miles)" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="0" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="0.00" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="20" /></td>
                <td><input className="p-2 border rounded w-full" placeholder="0.00" /></td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div>
            <label className="block text-sm font-medium">Notes to Customer</label>
            <textarea className="p-2 border rounded w-full h-24" placeholder="E.g., Please quote invoice number with payment. Thank you for your business." />
          </div>
          <div>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '200px' }}><strong>Subtotal</strong></td>
                  <td><input className="p-2 border rounded w-40" placeholder="0.00" /></td>
                </tr>
                <tr>
                  <td><strong>VAT %</strong></td>
                  <td><input className="p-2 border rounded w-40" placeholder="20" /></td>
                </tr>
                <tr>
                  <td><strong>VAT Amount</strong></td>
                  <td><input className="p-2 border rounded w-40" placeholder="0.00" /></td>
                </tr>
                <tr>
                  <td><strong>Total Due</strong></td>
                  <td><input className="p-2 border rounded w-40" placeholder="0.00" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Payment Details */}
        <h4 className="text-lg font-semibold mb-2">Payment Details</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-2">
          <input className="p-2 border rounded w-full" placeholder="Bank Name" />
          <input className="p-2 border rounded w-full" placeholder="Account Name" />
          <input className="p-2 border rounded w-full" placeholder="Account Number" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-2">
          <input className="p-2 border rounded w-full" placeholder="Sort Code" />
          <input className="p-2 border rounded w-full" placeholder="IBAN" />
          <input className="p-2 border rounded w-full" placeholder="SWIFT/BIC" />
        </div>
        <p className="text-sm text-gray-700 mb-4">Payment terms: Net ____ days from receipt of a valid invoice unless otherwise agreed in writing.</p>

        {/* Print Button */}
        <div className="mb-4 text-right">
          <button
            type="button"
            onClick={() => window.print()}
            className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
          >
            Print Invoice
          </button>
        </div>
      </div>
    </>
  );
}

export default InvoiceTemplate;